var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4975F1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.5 832c4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5-4.142 0-7.5-3.358-7.5-7.5 0-4.142 3.358-7.5 7.5-7.5zm1.318 6.195h-.351l-1.987.323-.076.234.149-.005h.062c.13 0 .23.032.305.099.074.066.111.142.111.228 0 .11-.025.261-.075.456l-.042.154-.814 2.8c-.067.223-.1.407-.1.551 0 .219.075.4.226.542.15.143.352.214.606.214.62 0 1.207-.447 1.762-1.342l.119-.199-.2-.117c-.245.379-.456.64-.632.785-.067.059-.133.088-.2.088-.038 0-.076-.019-.11-.056-.036-.037-.053-.077-.053-.12 0-.025.003-.059.01-.101l.034-.157.055-.21 1.201-4.167zm-.363-2.695c-.238 0-.44.084-.606.252-.166.168-.25.371-.25.61 0 .238.085.44.253.609.168.168.369.252.603.252.238 0 .441-.084.61-.252.167-.168.251-.371.251-.61 0-.238-.083-.441-.249-.609-.166-.168-.37-.252-.612-.252z",
    transform: "translate(-250 -832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueInfo);
export default __webpack_public_path__ + "static/media/blueInfo.3d30bece26b97194e9493c3ac9fd6340.svg";
export { ForwardRef as ReactComponent };